import React from 'react';

/**
 * `ButtonAdd` is a thin styled wrapper around the shared `Button` component.
 *
 * It uses the "outlined" button styling plus the `cms-btn-add` CMS hook class,
 * and includes an additional `add-plan-button` class used by the UI.
 */

import Button from './Button';

type ButtonAddProps = {
  name: string;
  text: string;
  disabled?: boolean;
  onClick: (callback?: () => void) => void;
  waitText?: string;
  waitValue?: boolean;
  waitOnClick?: boolean;
  additionalClassNames?: string;
};

export const ButtonAdd = ({
  name,
  text,
  disabled,
  onClick,
  waitText,
  waitValue,
  waitOnClick,
  additionalClassNames
}: ButtonAddProps): JSX.Element => {
  let classes = 'button button-outlined-basic add-plan-button';

  if (additionalClassNames) {
    classes += ` ${additionalClassNames}`;
  }

  classes += ' cms-btn-add';

  return (
    <Button
      name={name}
      text={text}
      disabled={disabled}
      className={classes}
      onClick={onClick}
      waitValue={waitValue}
      waitText={waitText}
      waitOnClick={waitOnClick}
    />
  );
};
